<template>
  <div class="po" :class="{ 'po-blocked': blocked }" role="status">
    <div class="po-head">
      <span class="po-icon"><i class="fa" :class="blocked ? 'fa-pause-circle' : 'fa-star'"></i></span>
      <div>
        <strong class="po-title">{{ blocked ? 'التذاكر العاجلة موقوفة لحسابكم' : 'الدعم الفني السريع للمشتركين' }}</strong>
        <small class="po-sub">{{ blocked ? 'يمكنكم التواصل مع الدعم الفني بتذكرة عادية' : 'تذكرة عاجلة يتابعها فريق الدعم فوراً' }}</small>
      </div>
    </div>
    <div class="po-msg">{{ message || (blocked ? blockedText : paidText) }}</div>
    <div class="po-actions">
      <button v-if="blocked" type="button" class="po-btn po-btn-main" @click="$emit('normal')">
        <i class="fa fa-life-ring"></i> فتح تذكرة دعم فني
      </button>
      <button v-else type="button" class="po-btn po-btn-main" @click="subscribe">
        <i class="fa fa-star"></i> الاشتراك الآن
      </button>
      <button type="button" class="po-btn" @click="$emit('bot')">
        <i class="fa fa-magic"></i> اسأل المساعد الذكي
      </button>
      <a class="po-btn" :href="whatsapp" target="_blank" rel="noopener">
        <i class="fa fa-whatsapp"></i> تواصل معنا عبر واتساب
      </a>
    </div>
  </div>
</template>

<script>
import { WHATSAPP, PAID_ONLY, BLOCKED } from '@/views/support/support-api';

// Shown instead of the «الدعم الفني السريع» form when the school can't open urgent tickets:
//   state 'not_subscribed' (demo / none / expired) → «الاشتراك الآن» (no ticket for them);
//   state 'blocked' (stopped by the support team)  → «فتح تذكرة دعم فني» (a normal ticket).
// The assistant and WhatsApp are offered to both.
export default {
  props: {
    state: { type: String, default: 'not_subscribed' },
    message: { type: String, default: '' },
  },
  data(){
    return { paidText: PAID_ONLY, blockedText: BLOCKED, whatsapp: WHATSAPP };
  },
  computed: {
    blocked(){ return this.state == 'blocked'; },
  },
  methods: {
    subscribe(){ this.$router.push('/subscribes'); },
  },
};
</script>

<style scoped>
.po { display: flex; flex-direction: column; gap: 12px; }
.po-head { display: flex; align-items: center; gap: 12px; }
.po-icon { width: 46px; height: 46px; border-radius: 14px; display: inline-flex; align-items: center; justify-content: center;
  background: linear-gradient(135deg, #fbbf24, #d97706); color: #fff; font-size: 20px; flex: none; }
.po-title { display: block; font-size: 16px; color: #92400e; }
.po-sub { color: #6b7280; }
.po-msg { background: rgba(245, 158, 11, 0.1); border: 1px solid rgba(245, 158, 11, 0.35); border-radius: 12px;
  padding: 12px 14px; line-height: 1.8; color: #1f2937; }
.po-actions { display: flex; flex-wrap: wrap; gap: 8px; }
.po-btn { display: inline-flex; align-items: center; gap: 6px; padding: 10px 16px; border-radius: 10px; border: 1px solid #d1d5db;
  background: #fff; color: #1f2937; font-weight: 600; cursor: pointer; text-decoration: none; }
.po-btn:hover { border-color: #9ca3af; color: #111827; text-decoration: none; }
.po-btn:focus-visible { outline: 2px solid #2563eb; outline-offset: 2px; }
.po-btn-main { background: #d97706; border-color: #d97706; color: #fff; }
.po-btn-main:hover { background: #b45309; border-color: #b45309; color: #fff; }
.po-blocked .po-icon { background: linear-gradient(135deg, #64748b, #334155); }
.po-blocked .po-title { color: #334155; }
.po-blocked .po-msg { background: rgba(100, 116, 139, 0.08); border-color: rgba(100, 116, 139, 0.3); }
.po-blocked .po-btn-main { background: #334155; border-color: #334155; }
.po-blocked .po-btn-main:hover { background: #1e293b; border-color: #1e293b; }
@media (max-width: 480px) { .po-btn { flex: 1 1 100%; justify-content: center; } }
</style>
